export interface IColorControlProps {
    onToggle: (e: any) => void,
    style: any;
    active: boolean;
    label: string;
}

export const colorStyleMap: { [key: string]: any } = {
};